import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../../../../../cms/block/abstract-cms-block.component';

export interface IProductGeneralDetailsItemContent extends NICmsContentComponent.IData {
    copy: string;
}

@Component({
    selector: 'product-layout-details-general-item',
    templateUrl: './product-layout-details-general-item.component.html',
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductLayoutDetailsGeneralItemComponent>({
    id: 'product-general-details-item',
    block: {
        url: 'product-general-details-item'
    },
    onDemandOnly: true,
    name: 'General Details Item @ attribute code & value',
    description: 'Product page general details item @ attribute code & value',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            key: 'copy',
            default: 'Dolor sit amet'
        }
    ]
})
export class ProductLayoutDetailsGeneralItemComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductGeneralDetailsItemContent;
}
